import { css } from 'lit';

export const styles = css`
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 12px;
    color: inherit;
  }

  ::slotted(nile-icon) {
    width: 100%;
    height: 100%;
    color: inherit;
    fill: currentColor;
  }

 
  :host([collapsed]) {
    margin-right: 0;
    width: 100%;       
    justify-content: center;
  }

  nile-tooltip::part(body) {
    width: max-content;
    height: max-content;
    padding-top: var(--nile-spacing-xs, var(--ng-spacing-xs));
    padding-bottom: var(--nile-spacing-xs, var(--ng-spacing-xs));
    padding-left: var(--nile-spacing-sm, var(--ng-spacing-sm));
    padding-right: var(--nile-spacing-sm, var(--ng-spacing-sm));
    overflow-x: hidden;
  }
`;

export default [styles];
